import {
  actionTypes,
  enableBadgeToUserFailure,
  enableBadgeToUserSuccess,
  getUserAttachmentsInfoFailure,
  getUserAttachmentsInfoSuccess,
  paginatedUserRequestFailure,
  paginatedUserRequestSuccess,
  updateUserInfoFailure,
  updateUserInfoSuccess,
  uploadAttachmentsToUsersRequestFailure,
  uploadAttachmentsToUsersRequestSuccess,
  getUserAdminLettersInfoFailure,
  getUserAdminLettersInfoSuccess,
  uploadAttachmentsToAdminLettersRequestSuccess,
  uploadAttachmentsToAdminLettersRequestFailure,
  getAllRolesRequestSuccess,
  getAllRolesRequestFailure,
  getUsersValidationInfoSuccess,
  getUsersValidationInfoFailure,
  terminateConsultantSuccess,
  terminateConsultantFailure,
  terminateOutsourcerSuccess,
  terminateOutsourcerFailure,
  disableConsultantSuccess,
  disableConsultantFailure,
  disableOutsourcerSuccess,
  disableOutsourcerFailure,
  blockUserSuccess,
  blockUserFailure,
  renewUserSuccess,
  renewUserFailure,
  getOfficesSuccess,
  getOfficesFailure,
  getCompaniesSuccess,
  getCompaniesFailure,
  saveSocietyValidationSuccess,
  saveSocietyValidationFailure,
  getUserWithAlreadyExistingFiscalCodeSuccess,
  getUserWithAlreadyExistingFiscalCodeFailure,
  getOrganizationalUnitsFailure,
  getOrganizationalUnitsSuccess,
  getFieldVisibilitySuccess,
  getFieldVisibilityFailure,
  getButtonsSuccess,
  getButtonsFailure,
  renewUserAdminFailure,
  renewUserAdminSuccess,
  reactivateConsultantSuccess,
  reactivateConsultantFailure,
  reactivateOutsourcerSuccess,
  reactivateAdminSuccess,
  reactivateOutsourcerFailure,
  reactivateAdminFailure,
  terminateSecuritySuccess,
  terminateSecurityFailure,
  getExternalPortalComboOptionsSuccess,
  getExternalPortalComboOptionsFailure,
  externalPortalInsertUserSuccess,
  externalPortalInsertUserFailure,
  externalPortalUpdateUserSuccess,
  externalPortalUpdateUserFailure,
  reactivateUserSuccess,
  reactivateUserFailure,
  getUserTypeThatCanBeCreatedSuccess,
  getUserTypeThatCanBeCreatedFailure,
  getOrganizationalUnitsBySelectedRolesFailure,
  getOrganizationalUnitsBySelectedRolesSuccess,
  getReferralsSuccess,
  getReferralsFailure,
  getManagersSuccess,
  getManagersFailure,
  deleteAttachmentSuccess,
  deleteAttachmentFailure,
  validateUsersSuccess,
  validateUsersFailure,
} from "./actions";
import {
  fetchBlockUser,
  fetchDeleteAttachment,
  fetchDisableConsultant,
  fetchDisableOutsourcer,
  fetchEnableBadgeToUser,
  fetchGetButtons,
  fetchGetComboOptions,
  fetchGetCompanies,
  fetchGetFieldVisibility,
  fetchGetOffices,
  fetchGetRolesRequest,
  fetchGetUserAdminLettersInfo,
  fetchGetUserAttachmentsInfo,
  fetchGetUsersValidationInfo,
  fetchGetUserWithAlreadyExistingFiscalCode,
  fetchInsertUser,
  fetchManagersRequest,
  fetchOrganizationalUnitsBySelectedRolesRequest,
  fetchOrganizationalUnitsRequest,
  fetchPaginatedUserRequest,
  fetchReactivateAdmin,
  fetchReactivateConsultant,
  fetchReactivateOutsourcer,
  fetchReactivateUser,
  fetchReferralsRequest,
  fetchRenewUser,
  fetchRenewUserAdmin,
  fetchSaveSocietyValidation,
  fetchTerminateConsultant,
  fetchTerminateOutsourcer,
  fetchTerminateSecurity,
  fetchUpdateUser,
  fetchUpdateUserInfo,
  fetchUploadAttachmentToAdminLetters,
  fetchUploadAttachmentToUsers,
  fetchUserTypeThatCanBeCreated,
  validateUsersService,
} from "./services";

import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

const fetchGetUserWithAlreadyExistingFiscalCodeEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_USER_WITH_ALREADY_EXISTING_FISCAL_CODE),
    mergeMap((action: any) =>
      fetchGetUserWithAlreadyExistingFiscalCode(action.payload).pipe(
        map((response: any) =>
          getUserWithAlreadyExistingFiscalCodeSuccess(response)
        ),
        catchError((error: any) =>
          of(getUserWithAlreadyExistingFiscalCodeFailure(error))
        )
      )
    )
  );

const fetchGetCompaniesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_COMPANIES),
    mergeMap(() =>
      fetchGetCompanies().pipe(
        map((response: any) => getCompaniesSuccess(response)),
        catchError((error: any) => of(getCompaniesFailure(error)))
      )
    )
  );

const fetchSaveSocietyValidationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SAVE_SOCIETY_VALIDATION),
    mergeMap((action: any) =>
      fetchSaveSocietyValidation(action.payload).pipe(
        map((response: any) => saveSocietyValidationSuccess(response)),
        catchError((error: any) => of(saveSocietyValidationFailure(error)))
      )
    )
  );

const fetchGetOfficesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_OFFICES),
    mergeMap(() =>
      fetchGetOffices().pipe(
        map((response: any) => getOfficesSuccess(response)),
        catchError((error: any) => of(getOfficesFailure(error)))
      )
    )
  );

const fetchBlockUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.BLOCK_USER),
    mergeMap((action: any) =>
      fetchBlockUser(action.payload).pipe(
        map((response: any) => blockUserSuccess(response)),
        catchError((error: any) => of(blockUserFailure(error)))
      )
    )
  );

const fetchRenewUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.RENEW_USER),
    mergeMap((action: any) =>
      fetchRenewUser(action.payload).pipe(
        map((response: any) => renewUserSuccess(response)),
        catchError((error: any) => of(renewUserFailure(error)))
      )
    )
  );

const fetchRenewUserAdminEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.RENEW_USER_ADMIN),
    mergeMap((action: any) =>
      fetchRenewUserAdmin(action.payload).pipe(
        map((response: any) => renewUserAdminSuccess(response)),
        catchError((error: any) => of(renewUserAdminFailure(error)))
      )
    )
  );

const fetchReactivateOutsourcerEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.REACTIVATE_OUTSOURCER),
    mergeMap((action: any) =>
      fetchReactivateOutsourcer(action.payload).pipe(
        map((response: any) => reactivateOutsourcerSuccess(response)),
        catchError((error: any) => of(reactivateOutsourcerFailure(error)))
      )
    )
  );

const fetchReactivateConsultantEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.REACTIVATE_CONSULTANT),
    mergeMap((action: any) =>
      fetchReactivateConsultant(action.payload).pipe(
        map((response: any) => reactivateConsultantSuccess(response)),
        catchError((error: any) => of(reactivateConsultantFailure(error)))
      )
    )
  );

const fetchReactivateUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.REACTIVATE_USER),
    mergeMap((action: any) =>
      fetchReactivateUser(action.payload).pipe(
        map((response: any) => reactivateUserSuccess(response)),
        catchError((error: any) => of(reactivateUserFailure(error)))
      )
    )
  );

const fetchReactivateAdminEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.REACTIVATE_ADMIN),
    mergeMap((action: any) =>
      fetchReactivateAdmin(action.payload).pipe(
        map((response: any) => reactivateAdminSuccess(response)),
        catchError((error: any) => of(reactivateAdminFailure(error)))
      )
    )
  );

const fetchTerminateConsultantEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TERMINATE_CONSULTANT),
    mergeMap((action: any) =>
      fetchTerminateConsultant(action.payload).pipe(
        map((response: any) => terminateConsultantSuccess(response)),
        catchError((error: any) => of(terminateConsultantFailure(error)))
      )
    )
  );

const fetchTerminateOutsourcerEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TERMINATE_OUTSOURCER),
    mergeMap((action: any) =>
      fetchTerminateOutsourcer(action.payload).pipe(
        map((response: any) => terminateOutsourcerSuccess(response)),
        catchError((error: any) => of(terminateOutsourcerFailure(error)))
      )
    )
  );

const fetchTerminateSecurityEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TERMINATE_SECURITY),
    mergeMap((action: any) =>
      fetchTerminateSecurity(action.payload).pipe(
        map((response: any) => terminateSecuritySuccess(response)),
        catchError((error: any) => of(terminateSecurityFailure(error)))
      )
    )
  );

const validateUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VALIDATE_USERS),
    mergeMap((action: any) =>
      validateUsersService(action.payload).pipe(
        map((response: any) => validateUsersSuccess(response)),
        catchError((error: any) => of(validateUsersFailure(error)))
      )
    )
  );

const fetchDeleteAttachmentEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_ATTACHMENT),
    mergeMap((action: any) =>
      fetchDeleteAttachment(action.payload).pipe(
        map((response: any) => deleteAttachmentSuccess(response)),
        catchError((error: any) => of(deleteAttachmentFailure(error)))
      )
    )
  );

const fetchDisableConsultantEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DISABLE_CONSULTANT),
    mergeMap((action: any) =>
      fetchDisableConsultant(action.payload).pipe(
        map((response: any) => disableConsultantSuccess(response)),
        catchError((error: any) => of(disableConsultantFailure(error)))
      )
    )
  );

const fetchDisableOutsourcerEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DISABLE_OUTSOURCER),
    mergeMap((action: any) =>
      fetchDisableOutsourcer(action.payload).pipe(
        map((response: any) => disableOutsourcerSuccess(response)),
        catchError((error: any) => of(disableOutsourcerFailure(error)))
      )
    )
  );

const fetchGetUsersValidationInfoEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_USERS_VALIDATION_INFO),
    mergeMap((action: any) =>
      fetchGetUsersValidationInfo(action.payload).pipe(
        map((response: any) => getUsersValidationInfoSuccess(response)),
        catchError((error: any) => of(getUsersValidationInfoFailure(error)))
      )
    )
  );

const fetchGetAllRolesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ALL_ROLES_REQUEST),
    mergeMap(() =>
      fetchGetRolesRequest().pipe(
        map((response: any) => getAllRolesRequestSuccess(response)),
        catchError((error: any) => of(getAllRolesRequestFailure(error)))
      )
    )
  );

const fetchPaginatedUserRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.PAGINATED_USERS_REQUEST),
    mergeMap((action: any) =>
      fetchPaginatedUserRequest(action.payload).pipe(
        map((response: any) => paginatedUserRequestSuccess(response)),
        catchError((error: any) => of(paginatedUserRequestFailure(error)))
      )
    )
  );

const fetchUpdateUserInfoEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_USER_INFO),
    mergeMap((action: any) =>
      fetchUpdateUserInfo(action.id, action.payload).pipe(
        map((response: any) => updateUserInfoSuccess(response)),
        catchError((error: any) => of(updateUserInfoFailure(error)))
      )
    )
  );

const fetchEnableBadgeToUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ENABLE_BADGE_TO_USER),
    mergeMap((action: any) =>
      fetchEnableBadgeToUser(action.payload).pipe(
        map((response: any) => enableBadgeToUserSuccess(response)),
        catchError((error: any) => of(enableBadgeToUserFailure(error)))
      )
    )
  );

const fetchGetUserAttachmentsInfoEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_USER_ATTACHMENTS_INFO),
    mergeMap((action: any) =>
      fetchGetUserAttachmentsInfo(action.payload).pipe(
        map((response: any) => getUserAttachmentsInfoSuccess(response)),
        catchError((error: any) => of(getUserAttachmentsInfoFailure(error)))
      )
    )
  );

const fetchGetUserAdminLettersInfoEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_USER_ADMIN_LETTERS_INFO),
    mergeMap((action: any) =>
      fetchGetUserAdminLettersInfo(action.payload).pipe(
        map((response: any) => getUserAdminLettersInfoSuccess(response)),
        catchError((error: any) => of(getUserAdminLettersInfoFailure(error)))
      )
    )
  );

const fetchUploadAttachmentsToAdminLettersEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPLOAD_ATTACHMENTS_TO_ADMIN_LETTERS),
    mergeMap((action: any) =>
      fetchUploadAttachmentToAdminLetters(action.payload).pipe(
        map((response: any) =>
          uploadAttachmentsToAdminLettersRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(uploadAttachmentsToAdminLettersRequestFailure(error))
        )
      )
    )
  );

const fetchUploadAttachmentsToUsersEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPLOAD_ATTACHMENTS_TO_USERS),
    mergeMap((action: any) =>
      fetchUploadAttachmentToUsers(action.payload).pipe(
        map((response: any) =>
          uploadAttachmentsToUsersRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(uploadAttachmentsToUsersRequestFailure(error))
        )
      )
    )
  );

const fetchGetReferralsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_REFERRALS),
    mergeMap((action: any) =>
      fetchReferralsRequest(action.payload).pipe(
        map((response: any) => getReferralsSuccess(response)),
        catchError((error: any) => of(getReferralsFailure(error)))
      )
    )
  );

const fetchGetManagersEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_MANAGERS),
    mergeMap((action: any) =>
      fetchManagersRequest(action.payload).pipe(
        map((response: any) => getManagersSuccess(response)),
        catchError((error: any) => of(getManagersFailure(error)))
      )
    )
  );

const fetchGetOrganizationalUnitsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ORGANIZATIONAL_UNITS),
    mergeMap((action: any) =>
      fetchOrganizationalUnitsRequest(action.payload).pipe(
        map((response: any) => getOrganizationalUnitsSuccess(response)),
        catchError((error: any) => of(getOrganizationalUnitsFailure(error)))
      )
    )
  );

const fetchGetFieldVisibilityEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_FIELD_VISIBILITY),
    mergeMap((action: any) =>
      fetchGetFieldVisibility(action.payload).pipe(
        map((response: any) => getFieldVisibilitySuccess(response)),
        catchError((error: any) => of(getFieldVisibilityFailure(error)))
      )
    )
  );

const fetchGetButtonsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_BUTTONS),
    mergeMap((action: any) =>
      fetchGetButtons(action.payload).pipe(
        map((response: any) => getButtonsSuccess(response)),
        catchError((error: any) => of(getButtonsFailure(error)))
      )
    )
  );

const fetchExternalPortalComboOptionsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_EXTERNAL_PORTAL_COMBO_OPTIONS),
    mergeMap((action: any) =>
      fetchGetComboOptions(action.payload).pipe(
        map((response: any) => getExternalPortalComboOptionsSuccess(response)),
        catchError((error: any) =>
          of(getExternalPortalComboOptionsFailure(error))
        )
      )
    )
  );

const fetchExternalPortalInsertUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.EXTERNAL_PORTAL_INSERT_USER),
    mergeMap((action: any) =>
      fetchInsertUser(action.payload.roles, action.payload.body).pipe(
        map((response: any) => externalPortalInsertUserSuccess(response)),
        catchError((error: any) => of(externalPortalInsertUserFailure(error)))
      )
    )
  );

const fetchExternalPortalUpdateUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.EXTERNAL_PORTAL_UPDATE_USER),
    mergeMap((action: any) =>
      fetchUpdateUser(
        action.payload.userCode,
        action.payload.roles,
        action.payload.body
      ).pipe(
        map((response: any) => externalPortalUpdateUserSuccess(response)),
        catchError((error: any) => of(externalPortalUpdateUserFailure(error)))
      )
    )
  );

const fetchUserTypeThatCanBeCreatedEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_USER_TYPE_THAT_CAN_BE_CREATED),
    mergeMap((action: any) =>
      fetchUserTypeThatCanBeCreated(action.payload).pipe(
        map((response: any) => getUserTypeThatCanBeCreatedSuccess(response)),
        catchError((error: any) =>
          of(getUserTypeThatCanBeCreatedFailure(error))
        )
      )
    )
  );

const fetchGetOrganizationalUnitsBySelectedRolesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ORGANIZATIONAL_UNITS_BY_SELECTED_ROLES),
    mergeMap((action: any) =>
      fetchOrganizationalUnitsBySelectedRolesRequest(action.payload).pipe(
        map((response: any) =>
          getOrganizationalUnitsBySelectedRolesSuccess(response)
        ),
        catchError((error: any) =>
          of(getOrganizationalUnitsBySelectedRolesFailure(error))
        )
      )
    )
  );

export default [
  fetchGetUsersValidationInfoEpic,
  fetchGetAllRolesEpic,
  fetchPaginatedUserRequestEpic,
  fetchUploadAttachmentsToAdminLettersEpic,
  fetchUploadAttachmentsToUsersEpic,
  fetchUpdateUserInfoEpic,
  fetchEnableBadgeToUserEpic,
  fetchGetUserAttachmentsInfoEpic,
  fetchGetUserAdminLettersInfoEpic,
  fetchTerminateConsultantEpic,
  fetchTerminateOutsourcerEpic,
  fetchDisableConsultantEpic,
  fetchDisableOutsourcerEpic,
  fetchBlockUserEpic,
  fetchRenewUserEpic,
  fetchGetOfficesEpic,
  fetchGetCompaniesEpic,
  fetchSaveSocietyValidationEpic,
  fetchGetUserWithAlreadyExistingFiscalCodeEpic,
  fetchGetOrganizationalUnitsEpic,
  fetchGetFieldVisibilityEpic,
  fetchGetButtonsEpic,
  fetchRenewUserAdminEpic,
  fetchReactivateOutsourcerEpic,
  fetchReactivateConsultantEpic,
  fetchReactivateAdminEpic,
  fetchTerminateSecurityEpic,
  fetchExternalPortalComboOptionsEpic,
  fetchExternalPortalInsertUserEpic,
  fetchReactivateUserEpic,
  fetchExternalPortalUpdateUserEpic,
  fetchUserTypeThatCanBeCreatedEpic,
  fetchGetOrganizationalUnitsBySelectedRolesEpic,
  fetchGetReferralsEpic,
  fetchGetManagersEpic,
  fetchDeleteAttachmentEpic,
  validateUserEpic,
];
